
import NoticeList from '@/pages/message/notice-list';


// 公告通知列表
export const noticeList = {
  path: 'message/noticeList',
  component: NoticeList
}




// WEBPACK FOOTER //
// ./src/router/message.js